import { useSearchParams } from "react-router-dom";
import {
    Alert,
    CircularProgress,
    Stack,
    Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { doApiPost, ErrorType } from "../../api/Requests";
import { loginAndReturnTo } from "./LoginScreen";
import { useTranslation } from "react-i18next";
import {
    AuthBox,
    FlexRowBox,
    LeftContent,
    RightContent
} from "./Authentication.styles";
import BonisoftLogo from "../../common/ui/BonisoftLogo";
import AuthLayout from "./AuthLayout";

/**
 * This screen handles the email verification link. It uses the url-provided token and validates
 * it with the backend. It logs in the user if needed.
 */
export default function LinkingEmailConfirmationScreen() {
    const [searchParams] = useSearchParams();
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const token = searchParams.get("token");
    const userId = searchParams.get("user");
    const { t } = useTranslation();
    const url = window.location.href;

    useEffect(() => {
        const validateEmail = async () => {
            const result = await doApiPost<any, never>(
                `/api/users/${userId}/confirmation/${token}`,
                null,
                { handleUnauthenticated: true }
            );

            if (result.success()) {
                setIsSuccess(true);
                setIsError(false);
            } else if (result.errorType === ErrorType.AuthenticationError) {
                loginAndReturnTo(url);
            } else {
                setIsError(true);
                setIsSuccess(false);
            }
        };

        validateEmail();
    }, [token, userId]);

    return (
        <AuthLayout>
            <AuthBox>
                <FlexRowBox>
                    <LeftContent>
                        <Stack spacing={3} alignItems="center" justifyContent="center" height="100%">
                            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                                {t("authentication.authSettings.confirmingEmail")}
                            </Typography>

                            {!isError && !isSuccess && <CircularProgress />}

                            {isError && (
                                <Alert severity="error" sx={{ width: "100%" }}>
                                    {t("authentication.authSettings.confirmEmailError")}
                                </Alert>
                            )}

                            {isSuccess && (
                                <Alert severity="success" sx={{ width: "100%" }}>
                                    {t("authentication.authSettings.confirmEmailSuccess")}
                                </Alert>
                            )}
                        </Stack>
                    </LeftContent>

                    <RightContent>
                        <BonisoftLogo imgRatio={30} />
                    </RightContent>
                </FlexRowBox>
            </AuthBox>
        </AuthLayout>
    );
}
